// extracted by mini-css-extract-plugin
module.exports = {"record":"CXnt","headerGroup":"CXo7","comments":"CXm7","advMarker":"CXlx"};